import axios from 'axios';

const auth = {
    state: {
        access_token: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null,
        username: localStorage.getItem('username') ? localStorage.getItem('username') : null,
        email: localStorage.getItem('email') ? localStorage.getItem('email') : null
    },
    mutations: {
        LOGIN(state, payload) {
            localStorage.setItem('access_token', payload.access_token.token)
            localStorage.setItem('username', payload.user.username)
            localStorage.setItem('email', payload.user.email)

            state.access_token = payload.access_token.token
            state.username = payload.user.username
            state.email = payload.user.email
        },
        LOGOUT(state) {
            localStorage.removeItem('access_token')
            localStorage.removeItem('username')
            localStorage.removeItem('email')

            state.access_token = null
            state.username = null
            state.email = null
        }
    },
    actions: {
        authenticate: async ({
            commit
        }, {
            email,
            password
        }) => {

            try {
                const payload = await axios.post(`${process.env.VUE_APP_API}/auth/login`, {
                    email,
                    password
                })

                commit('LOGIN', payload.data)

                return {
                    status: 200,
                    message: 'Success',
                    data: payload.data
                }

            } catch (e) {
                return {
                    status: 401,
                    message: 'Error',
                    error: e
                }
            }
        },
        logout: ({
            commit
        }) => {
            commit('LOGOUT')
        }
    },
    getters: {
        isLogged: state => state.access_token !== null,
        username: state => state.username,
        email: state => state.email
    }
}

export default auth